// extracted by mini-css-extract-plugin
export default {"HighLevelLocation":"high-level-location_HighLevelLocation__-B14m"};